import { render, staticRenderFns } from "./orderview.vue?vue&type=template&id=b0415b82&scoped=true"
import script from "./orderview.vue?vue&type=script&lang=js"
export * from "./orderview.vue?vue&type=script&lang=js"
import style0 from "./orderview.vue?vue&type=style&index=0&id=b0415b82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0415b82",
  null
  
)

export default component.exports